import React from "react";

function Utilities() {
	return (
		<div className="container">
			<div className="container--inner">
				<h1>Utilities</h1>
			</div>
		</div>
	);
}

export default Utilities;
